
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';

const EmailConfirmed = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if there's pending signup data
    const pendingSignup = localStorage.getItem('pendingSignup');
    if (pendingSignup) {
      const { redirectAfterPayment } = JSON.parse(pendingSignup);
      if (redirectAfterPayment) {
        // Clear the pending signup data
        localStorage.removeItem('pendingSignup');
        // Redirect to the specified page (in this case, /auth)
        setTimeout(() => {
          navigate(redirectAfterPayment);
        }, 3000);
      }
    }
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md space-y-8">
        <div className="flex justify-center mb-8">
          <img 
            src="/lovable-uploads/32ad3d71-609b-4f99-b5d8-70c212e9146b.png" 
            alt="MindNote Logo" 
            className="h-25"
          />
        </div>
        <Card className="p-8 text-center space-y-6">
          <div className="flex justify-center">
            <CheckCircle className="h-16 w-16 text-green-500" />
          </div>
          <h1 className="text-2xl font-bold text-foreground">Email Verified!</h1>
          <p className="text-muted-foreground">
            Your email has been successfully verified. You will be redirected to the login page in a few seconds.
          </p>
          <Button
            onClick={() => navigate('/auth')}
            className="w-full"
          >
            Go to Login
          </Button>
        </Card>
      </div>
    </div>
  );
};

export default EmailConfirmed;
